import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'

const LoggedUserProfileButton = () => {
  const intl = useIntl()

  return (
    <div className="menu-item px-5">
      <Link
        className="menu-link px-5"
        to={'/account/profile'}
      >
        {intl.formatMessage({ id: 'user_profile' })}
      </Link>
    </div>
  )
}

export { LoggedUserProfileButton }
